import { useState } from 'react'
import { useNavigate } from 'react-router'

import { useCreateConfiguration } from 'query/useConfigurations'
import { Alert, Button, Field, Form, FormActions, FormCard, Input, PageContent, PageHeader } from 'ui'

export const DeploymentsNew = () => {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const { error, isPending, mutate } = useCreateConfiguration({
    onSuccess: ({ id }) => navigate(`/configurations/${id}`),
  })

  return (
    <>
      <PageHeader subtitle="Create a shared set of drives, app behavior, and license rules for your team." title="New Configuration" />
      <PageContent>
        <Form className="tw:mx-auto tw:max-w-form" onSubmit={event => { event.preventDefault(); mutate({ name }) }}>
          {error && <Alert color="danger">{error.message || 'Failed to create configuration. Please try again.'}</Alert>}
          <FormCard title="Configuration Settings">
            <Field helper="Choose a clear name your team will recognize." label="Name">
              <Input autoFocus name="name" onChange={event => setName(event.target.value)} value={name} />
            </Field>
          </FormCard>
          <FormActions className="tw:mt-5">
            <Button onClick={() => navigate('/configurations')} type="button" variant="secondary">Cancel</Button>
            <Button disabled={isPending || !name.trim()} type="submit">{isPending ? 'Creating…' : 'Create Configuration'}</Button>
          </FormActions>
        </Form>
      </PageContent>
    </>
  )
}
